import crud from '@/crud/index/index'

import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  mixins: [crud],

  resourcePath: 'v1/professional/schedules/statistics/specialities'
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/abstract-speciality/resources/index.js